import {ACCESS_TOKEN_KEY} from '../models/storageKeys';
import {Menu, User} from '../models/session';
import {computed, signal} from '@angular/core';
import {intersection} from 'lodash-es';

export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('')
    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
  return JSON.parse(jsonPayload);
}

export const tokenToUser = (token: string): User => {
  const claims = parseJwt(token);
  claims.exp = claims.exp * 1000;
  return {...claims.user, exp: new Date(claims.exp)};
}

export const getUserFromSession = () => {
  try {
    const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
    if (!!token) {
      return tokenToUser(token);
    }
  } catch (e) {
  }
  return null;
}

export const filterMenuItems = (mainRole: string, subRoles: string[], menus: Menu[], compound: string) => {
  const validUrls: any = [];
  menus.forEach(m => {
    m.menu_items = m.menu_items.filter(i => {
      const allowed = (intersection(i.compounds, [compound]).length > 0 && intersection(subRoles, i.roles).length > 0) || mainRole === 'admin' || i.roles.includes("*");
      i.urlSegment = ['/', m.link, ...i.link.split('/')];
      if (i.portal) {
        i.queryParams = {module: [m.link, ...i.link.split('/')].join('/')}
        i.urlSegment = ['/', 'forward'];
      }
      if (i.visible && allowed) {
        validUrls.push([m.link, ...i.link.split('/')]);
        return true;
      }
      return false;
    })
  });
  return [
    menus.filter(m => m.menu_items.length > 0),
    validUrls
  ];
}


export const user$ = signal<User>(getUserFromSession());
export const isAuthenticated$ = computed(() => user$());
export const isDevEnv = window.location.hostname === 'localhost';
